/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../generated-types/appsync";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const queryMessages = /* GraphQL */ `query QueryMessages($jobRunId: String!, $nextToken: String) {
  queryMessages(jobRunId: $jobRunId, nextToken: $nextToken) {
    items {
      jobRunId
      messageId
      event
      message
      time
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.QueryMessagesQueryVariables,
  APITypes.QueryMessagesQuery
>;
